import { Button } from "@mui/material";

export const TR_CRO_VIEW_HEAD = (navigate, fromDate, toDate, projectId) => [
  { field: "slNo", headerName: "Sl No", width: 80 },
  { field: "croName", headerName: "CRO Name", width: 250 },
  { field: "replacementCount", headerName: "Total Replaced", width: 200 },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            background:
              "linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))",
            color: "#fff",
            "&:hover": {
              background:
                "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))",
            },
            px: "10px",
          }}
          onClick={() => {
            navigate(
              `/my-workspace/trt-studentdetails?fromDate=${fromDate}&toDate=${toDate}&croId=${params.row.croId}&projectId=${projectId}`
            );
          }}
        >
          View Report
        </Button>
      );
    },
  },
];
